import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { z } from 'zod';

export function getAccountValidationForBackgroundCheckSchema({
    type,
    requiredInfoText = 'Required Info',
    invalidAddressLine1 = 'Address Line 1 should contain house number and street name separated by space',
    invalidPostalCode = 'Invalid Postal Code',
}: {
    type: BackgroundCheckType;
    requiredInfoText?: string;
    invalidAddressLine1?: string;
    invalidPostalCode?: string;
}) {
    const firstName = z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText });
    const lastName = z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText });
    const ssn = z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText });
    const dateOfBirth = z
        .string({ required_error: requiredInfoText })
        .trim()
        .min(1, { message: requiredInfoText })
        .pipe(z.coerce.date({ required_error: requiredInfoText }));
    const email = z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }).email();
    const stateOfWork = z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText });
    const address = z
        .object(
            {
                addressLine1: z
                    .string({ required_error: requiredInfoText })
                    .trim()
                    .min(1, { message: requiredInfoText })
                    .regex(/\s/, { message: invalidAddressLine1 }),
                city: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
                state: z.string({ required_error: requiredInfoText }).trim().min(1, { message: requiredInfoText }),
                postalCode: z
                    .string({ required_error: requiredInfoText })
                    .trim()
                    .min(1, { message: requiredInfoText })
                    .regex(/^[0-9]{5}(?:-[0-9]{4})?$/, { message: invalidPostalCode }),
            },
            { message: requiredInfoText },
        )
        .default({ addressLine1: '', city: '', postalCode: '', state: '' });
    const genderId = z.string({ required_error: requiredInfoText }).uuid({ message: requiredInfoText });

    const standardValidation = z.object({
        firstName,
        lastName,
        ssn,
        dateOfBirth,
        email,
        stateOfWork,
        address,
    });

    const coriValidation = z.object({
        firstName,
        lastName,
        dateOfBirth,
        address,
        genderId,
    });

    const vsosValidation = z.object({
        firstName,
        lastName,
        dateOfBirth,
        stateOfWork,
    });

    const jnetValidation = z.object({
        firstName,
        lastName,
        dateOfBirth,
        ssn,
    });

    switch (type) {
        case 'cori':
            return coriValidation;
        case 'vsos':
            return vsosValidation;
        case 'jnet':
            return jnetValidation;
        default:
            return standardValidation;
    }
}
